module.exports = __webpack_public_path__ + "img/planet-p1-3.a21042bf.png";